export default __webpack_public_path__ + "static/xmas-nav-3be37fd6547500dae6f2908237828497.png";